import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { useLocale } from "@/modules/locales/useLocale"
import { useTracking } from "@/modules/tracking/useTracking"

type CompanyExternalLinkTrackFunction = (url: string | URL, type: string) => void

export const useCompanyExternalLinkTrack = (): CompanyExternalLinkTrackFunction => {
  const locale = useLocale()
  const tracking = useTracking()
  const { dataCompany } = useCompanyFetch()
  const { dataCareerCenter } = useCareerCenterFetch()

  return (url: string | URL, type: string) =>
    tracking?.track("external_link_click", {
      company_id: dataCompany?.id || null,
      destination_url: url.toString(),
      link_type: type,
      service: "company",
      trackee_locale: locale,
      ...(dataCareerCenter?.intranet && { school_id: dataCareerCenter?.id }),
    })
}
